import { render, staticRenderFns } from "./order-guide.vue?vue&type=template&id=612b4ff2&scoped=true&"
import script from "./order-guide.vue?vue&type=script&lang=js&"
export * from "./order-guide.vue?vue&type=script&lang=js&"
import style0 from "./order-guide.vue?vue&type=style&index=0&id=612b4ff2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b4ff2",
  null
  
)

export default component.exports